var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',_vm._g(_vm._b({staticClass:"modal-confirm"},'BaseModal',_vm.attributes,false),_vm.$listeners),[(_vm.title)?_c('BaseTitle',_vm._b({},'BaseTitle',_vm.title,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }